import request from "@utils/request";

/**
 * 获取关于我们-联系我们的数据(无)
 */
// export function getHonorDatain(data) {
//   return request.get("honor_list", data, { login: false });
// }

/**
 * 获取关于我们-荣誉资质的数据
 */
export function getHonorData(data) {
  return request.get("honor", data, { login: false });
}

/**
 * 获取关于我们-荣誉资质内部的数据
 */
export function getHonorDatain(data) {
  return request.get("honor_list", data, { login: false });
}

/**
 * 获取关于我们-产品案例的数据
 */
export function getCaseData(data) {
  return request.get("/product/demo", data, { login: false });
}

/**
 * 获取关于我们-公司简介的数据
 */
export function getCompanyData(data) {
  return request.get("/contact", data, { login: false });
}
/**
 * 获取关于我们-视频教学的数据
 */
export function getVideoData(data) {
  return request.get("/teach", data, { login: false });
}
/**
 * 获取关于我们-视频教学一级的模糊查询
 */
export function getSearchData(data) {
  return request.get("/taech_search", data, { login: false });
}

/**
 * 获取关于我们-视频教学2级的数据
 */
export function getVideo2Data(data) {
  return request.get("/teach_list", data, { login: false });
}

/**
 * 获取关于我们-视频教学2级的模糊查询
 */
export function search2Data(data) {
  return request.get("/video_search", data, { login: false });
}

/**
 * 获取关于我们-项目定制数据
 */
export function projectCustom(data) {
  return request.get("/subject_submit", data, { login: false });
}
/**
 * 获取关于我们-案例列表数据
 */
export function example(data) {
  return request.get("/case_sort", data, { login: false });
}
export function example0(data) {
  return request.get("/example", data, { login: false });
}

/**
 * 获取关于我们-案例列表详情数据
 */
export function exampleDetail(data) {
  return request.get("/example_detail", data, { login: false });
}

/**
 * 获取关于我们-活动详情数据
 */
export function actionDetail(data) {
  return request.get("/one_example_detail", data, { login: false });
}

/**
 * 获取关于我们-资料列表详情数据
 */
export function getword(data) {
  return request.get("/word", data, { login: false });
}

/**
 * 获取关于我们-资料列表详情数据
 */
export function searchData(data) {
  return request.get("/word_search", data, { login: false });
}
